import { useAuth } from "./auth.provider";

export default function CanAny({ permissions, children, fallback = null }) {
    const { canAny } = useAuth();
    return canAny(permissions) ? children : fallback;
}